/**
 * Static parent/child relationships between profile fields
 *
 * mirrors the backend's authoritative `FIELD_PARENT` map
 * (headtotoe-backend: src/profileFields/constants/profileFields.constants.js).
 */

export const CHILD_FIELD_BY_FIELD = {
  profession: 'role',
  role: 'levelOfTraining',
};

/**
 * `scope` of the option affected-users endpoint: users who'd lose a dependent value on
 * delete (they block it), or everyone holding the option.
 */
export const AFFECTED_USERS_SCOPES = {
  DEPENDENTS: 'DEPENDENTS',
  HOLDERS: 'HOLDERS',
};

/** `code` values in profile-fields API error bodies. */
export const PROFILE_FIELDS_ERROR_CODES = {
  OPTION_HAS_AFFECTED_USERS: 'PROFILE_FIELD_OPTION_HAS_AFFECTED_USERS',
};

export const PARENT_FIELD_BY_FIELD = {
  role: 'profession',
  levelOfTraining: 'role',
};
